import { author, currentlyDoing, getStats, profileBullets } from '../data/profile';
import './Bento.css';

export function Bento() {
  const stats = getStats();
  return (
    <section className="bento" id="profile" aria-label="At a glance">
      <article className="bento-card bento-about" data-reveal>
        <header className="card-head">
          <span className="card-tag">01 / Profile</span>
          <h2>About</h2>
        </header>
        <p className="card-lead">
          Backend-first product engineer. A decade shipping Rails, currently invested in
          Rust, Go, and the design of distributed systems. Calm under deadlines, allergic
          to bullshit, and biased toward simple solutions that age well.
        </p>
        <ul className="profile-list">
          {profileBullets.map((item) => (
            <li key={item}>
              <span className="profile-bullet" aria-hidden>—</span>
              {item}
            </li>
          ))}
        </ul>
      </article>

      <article className="bento-card bento-stats" data-reveal>
        <header className="card-head">
          <span className="card-tag">02 / Numbers</span>
          <h2>Footprint</h2>
        </header>
        <div className="stat-grid">
          {stats.map((stat) => (
            <div key={stat.label} className="stat-cell">
              <span className="stat-value">{stat.value}</span>
              <span className="stat-label">{stat.label}</span>
            </div>
          ))}
        </div>
      </article>

      <article className="bento-card bento-now" data-reveal>
        <header className="card-head">
          <span className="card-tag">03 / Current</span>
          <h2>Now</h2>
        </header>
        <ul className="now-list">
          {currentlyDoing.map((item) => (
            <li key={item.key}>
              <span className="now-key">{item.key}</span>
              <span className="now-val">{item.value}</span>
            </li>
          ))}
        </ul>
      </article>

      <article className="bento-card bento-call" data-reveal>
        <span className="call-eyebrow">04 / Open to</span>
        <p className="call-headline">
          Senior product engineering roles, Rails refactors, and zero-bullshit teams.
        </p>
        <a className="call-link" href={`mailto:${author.email}`}>
          {author.email}
          <span aria-hidden>↗</span>
        </a>
      </article>
    </section>
  );
}
